import { render, staticRenderFns } from "./GamificationDetail.vue?vue&type=template&id=52d7f326&scoped=true"
import script from "./GamificationDetail.vue?vue&type=script&lang=js"
export * from "./GamificationDetail.vue?vue&type=script&lang=js"
import style0 from "./GamificationDetail.vue?vue&type=style&index=0&id=52d7f326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d7f326",
  null
  
)

export default component.exports